import React, { useMemo } from "react";
import { Building2, Layers, Sigma } from "lucide-react";

import { useRelatorioSabores } from "../context/RelatorioSaboresContext";
import { lojasDistintasCount } from "../utils/relatorioSaboresChartData";

const PizzasPorSaborKpiStrip: React.FC = () => {
  const { linhas, isLoading, totalQuantidade, appliedFilters } =
    useRelatorioSabores();

  const lojasNoResultado = useMemo(() => lojasDistintasCount(linhas), [linhas]);

  if (appliedFilters == null) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-3 sm:gap-6">
      <div className="relative overflow-hidden rounded-2xl border border-neutral-200/80 bg-gradient-to-br from-white to-neutral-50 p-5 shadow-sm">
        <div className="absolute right-3 top-3 rounded-lg bg-primary/10 p-2 text-primary">
          <Sigma size={20} strokeWidth={2} />
        </div>
        <p className="text-xs font-medium uppercase tracking-wide text-neutral-500">
          Soma das quantidades
        </p>
        <p className="mt-1 text-3xl font-bold tabular-nums text-neutral-900">
          {isLoading ? "—" : totalQuantidade.toLocaleString("pt-BR")}
        </p>
      </div>
      <div className="relative overflow-hidden rounded-2xl border border-neutral-200/80 bg-gradient-to-br from-white to-amber-50/40 p-5 shadow-sm">
        <div className="absolute right-3 top-3 rounded-lg bg-amber-100/90 p-2 text-amber-900">
          <Layers size={20} strokeWidth={2} />
        </div>
        <p className="text-xs font-medium uppercase tracking-wide text-neutral-500">
          Linhas no relatório
        </p>
        <p className="mt-1 text-3xl font-bold tabular-nums text-neutral-900">
          {isLoading ? "—" : linhas.length.toLocaleString("pt-BR")}
        </p>
      </div>
      <div className="relative overflow-hidden rounded-2xl border border-neutral-200/80 bg-gradient-to-br from-white to-teal-50/50 p-5 shadow-sm">
        <div className="absolute right-3 top-3 rounded-lg bg-teal-100/90 p-2 text-teal-900">
          <Building2 size={20} strokeWidth={2} />
        </div>
        <p className="text-xs font-medium uppercase tracking-wide text-neutral-500">
          Lojas no resultado
        </p>
        <p className="mt-1 text-3xl font-bold tabular-nums text-neutral-900">
          {isLoading ? "—" : lojasNoResultado.toLocaleString("pt-BR")}
        </p>
      </div>
    </div>
  );
};

export default PizzasPorSaborKpiStrip;
